import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import MinusButton from "../../../../components/MinusButton";
import PlusButton from "../../../../components/PlusButton";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { FIELDPERMISSIONS } from "../../../PermissionsConstants";
import { ICarrierMetricsPerState } from "../types";

interface CarrierMetricsPerStateProps {
  carrierMetrics: Array<ICarrierMetricsPerState>;
}
const CarrierMetrics = ({
  carrierMetrics,
}: CarrierMetricsPerStateProps): JSX.Element => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewFieldMetricsPerState =
    FIELDPERMISSIONS.fieldpermission_carrier_metricsperstate;
  //userPermissions?.includes(viewFieldMetricsPerState);
  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name:
      carrierMetrics.length > 0 && carrierMetrics[0].tableName
        ? carrierMetrics[0].tableName
        : "",
  });

  const tableArray =
    carrierMetrics.length > 0 && watch(`${carrierMetrics[0].tableName}`);
  const controlledFields =
    tableArray &&
    fields.map((field, index) => ({
      ...field,
      ...tableArray[index],
    }));
  useEffect(() => {
    if (carrierMetrics) {
      replace(carrierMetrics);
    }
  }, [carrierMetrics]);

  return (
    <>
      {controlledFields &&
        controlledFields.map((field, index) => {
          return (
            <div className="grid sm:grid-cols-10 py-1 px-2" key={field.id}>
              {userPermissions?.includes(viewFieldMetricsPerState) ? (
                <>
                  <div className="col-span-1 grid sm:grid-cols-2 px-2">
                    <div
                      className={`col-span-1 self-center w-1/2 ml-5 ${
                        index < 1 &&
                        carrierMetrics[0].parentRow === true &&
                        "mt-4"
                      }`}
                    >
                      {index > 0 ? (
                        <MinusButton
                          type="button"
                          onClick={() => remove(index)}
                        />
                      ) : (
                        <PlusButton
                          type="button"
                          onClick={(e) =>
                            append({
                              tableName: carrierMetrics[0]?.tableName,
                              parentRow: false,
                            })
                          }
                        />
                      )}
                    </div>
                    {carrierMetrics[0].tableName?.includes("metricState") && (
                      <div className="col-span-1">
                        <div
                          className={`grid grid-cols-1 w-full items-center gap-1 text-xs`}
                        >
                          {index < 1 &&
                            carrierMetrics[0].parentRow === true && (
                              <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                                State
                              </label>
                            )}

                          <TextInputHookFormDisabled
                            type="text"
                            register={register(
                              `${carrierMetrics[0].tableName}[${0}].state`,
                              {}
                            )}
                            className="font-bold"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-span-9 grid sm:grid-cols-6 content-center gap-x-2">
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Total PIF Count"
                          : undefined
                      }
                      type="text"
                      required={false}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].totalPifCount`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          // Remove non-digit characters and limit to two decimal places
                          const formattedValue = e.target.value
                            .replace(/[^\d.]/g, "")
                            .match(/^\d+(\.\d{0,2})?/);

                          if (formattedValue) {
                            e.target.value = formattedValue[0];
                          } else {
                            // Handle invalid input, e.g., clear the input
                            e.target.value = "";
                          }
                          setValue(
                            `${carrierMetrics[0].tableName}[${index}].totalPifCount`,
                            e ? e.target.value : null
                          );
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Total PIF Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].totalPifPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          // Remove non-digit characters and limit to two decimal places
                          const formattedValue = e.target.value
                            .replace(/[^\d.]/g, "")
                            .match(/^\d+(\.\d{0,2})?/);

                          if (formattedValue) {
                            e.target.value = formattedValue[0];
                          } else {
                            // Handle invalid input, e.g., clear the input
                            e.target.value = "";
                          }
                          setValue(
                            `${carrierMetrics[0].tableName}[${index}].totalPifPremium`,
                            e ? e.target.value : null
                          );
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "New Business Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].newBusinessPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          // Remove non-digit characters and limit to two decimal places
                          const formattedValue = e.target.value
                            .replace(/[^\d.]/g, "")
                            .match(/^\d+(\.\d{0,2})?/);

                          if (formattedValue) {
                            e.target.value = formattedValue[0];
                          } else {
                            // Handle invalid input, e.g., clear the input
                            e.target.value = "";
                          }
                          setValue(
                            `${carrierMetrics[0].tableName}[${index}].newBusinessPremium`,
                            e ? e.target.value : null
                          );
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Renewal Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].renewalPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          // Remove non-digit characters and limit to two decimal places
                          const formattedValue = e.target.value
                            .replace(/[^\d.]/g, "")
                            .match(/^\d+(\.\d{0,2})?/);

                          if (formattedValue) {
                            e.target.value = formattedValue[0];
                          } else {
                            // Handle invalid input, e.g., clear the input
                            e.target.value = "";
                          }
                          setValue(
                            `${carrierMetrics[0].tableName}[${index}].renewalPremium`,
                            e ? e.target.value : null
                          );
                        }
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-span-1 grid sm:grid-cols-2 px-2">
                    <div
                      className={`col-span-1 self-center w-1/2 ml-5 ${
                        index < 1 &&
                        carrierMetrics[0].parentRow === true &&
                        "mt-4"
                      }`}
                    >
                      {index > 0 ? (
                        <MinusButton
                          type="button"
                          onClick={() => remove(index)}
                          editStatus={true}
                        />
                      ) : (
                        <PlusButton
                          type="button"
                          onClick={(e) =>
                            append({
                              tableName: carrierMetrics[0]?.tableName,
                              parentRow: false,
                            })
                          }
                          disabled={true}
                        />
                      )}
                    </div>
                    {carrierMetrics[0].tableName?.includes("metricState") && (
                      <div className="col-span-1">
                        <div
                          className={`grid grid-cols-1 w-full items-center gap-1 text-xs`}
                        >
                          {index < 1 &&
                            carrierMetrics[0].parentRow === true && (
                              <label className="flex space-x-1 justify-start expandedLabel fontExpand">
                                State
                              </label>
                            )}

                          <TextInputHookFormDisabled
                            type="text"
                            register={register(
                              `${carrierMetrics[0].tableName}[${0}].state`,
                              {}
                            )}
                            className="font-bold"
                            disabled={true}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-span-9 grid sm:grid-cols-6 content-center gap-x-2">
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Total PIF Count"
                          : undefined
                      }
                      type="text"
                      required={false}
                      disabled={true}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].totalPifCount`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          var pifCount = e.target.value
                            .replace(/\D/g, null)
                            .match(/(\d{0,9})/);
                          if (pifCount) {
                            e.target.value = pifCount[1];
                          }
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Total PIF Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      disabled={true}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].totalPifPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          var pifPrem = e.target.value
                            .replace(/\D/g, null)
                            .match(/(\d{0,9})/);
                          if (pifPrem) {
                            e.target.value = pifPrem[1];
                          }
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "New Business Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      disabled={true}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].newBusinessPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          var newBusPrem = e.target.value
                            .replace(/\D/g, null)
                            .match(/(\d{0,9})/);
                          if (newBusPrem) {
                            e.target.value = newBusPrem[1];
                          }
                        }
                      }}
                    />
                    <TextInputLabelHookForm
                      label={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "Renewal Premium"
                          : undefined
                      }
                      type="text"
                      required={false}
                      disabled={true}
                      className={
                        errors?.[carrierMetrics[0]?.tableName ?? ""] &&
                        errors?.[carrierMetrics[0]?.tableName ?? ""][index]
                          ?.name &&
                        "border-2 border-red-500 col-span-2"
                      }
                      register={register(
                        `${carrierMetrics[0].tableName}[${index}].renewalPremium`,
                        {}
                      )}
                      secondDiv={
                        index < 1 && carrierMetrics[0].parentRow === true
                          ? "grid grid-cols-1"
                          : ""
                      }
                      onChange={(e) => {
                        if (e.target.value) {
                          var renewalPrem = e.target.value
                            .replace(/\D/g, null)
                            .match(/(\d{0,9})/);
                          if (renewalPrem) {
                            e.target.value = renewalPrem[1];
                          }
                        }
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          );
        })}
    </>
  );
};

export default CarrierMetrics;
